/* eslint-disable no-param-reassign */
import { getSpecificParent } from '@apia/util';
import { updatePanelPosition } from '../../position/usePanelPosition';
import { DragAndDrop } from '../util/DragAndDrop';

export function Drop(event: Event, DragAndDrop: DragAndDrop) {
  if (DragAndDrop.body) {
    const ev = event as DragEvent;
    const data = ev?.dataTransfer?.getData('text');

    const sections = DragAndDrop.body?.querySelectorAll('[data-locationid]');

    sections.forEach((sec) => {
      sec.setAttribute('style', '');
    });

    const draggingPanel = DragAndDrop.body.querySelector(
      `[data-panel][data-id="${DragAndDrop.draggingPanelId}"]:not(.apia_panel_falseDiv)`,
    );

    if (draggingPanel) {
      draggingPanel.setAttribute('style', '');
    }
    const falseDiv = document.querySelector('.apia_panel_falseDiv');

    if (data) {
      const child = document.querySelector(
        `[data-panel][data-id="${data}"]:not(.apia_panel_falseDiv)`,
      );
      sections.forEach((sec) => {
        if (sec.children.length === 1) {
          sec.setAttribute('style', '');
        }
      });
      if (falseDiv) {
        const newSection = getSpecificParent(
          falseDiv as HTMLElement,
          (current) => !!current.dataset.locationid,
        );

        if (newSection) {
          const panelsArray = Array.from(newSection.children);
          const childId = (child as HTMLElement).dataset.id;

          if (childId) {
            const index = panelsArray
              .filter(
                (panel) =>
                  !(
                    (panel as HTMLElement).dataset.id === childId &&
                    !(panel as HTMLElement).classList.contains(
                      'apia_panel_falseDiv',
                    )
                  ),
              )
              .findIndex(
                (panel) =>
                  (panel as HTMLElement).dataset.id === childId &&
                  (panel as HTMLElement).classList.contains(
                    'apia_panel_falseDiv',
                  ),
              );

            if (typeof index === 'number' && newSection.dataset.locationid) {
              void updatePanelPosition(
                childId,
                newSection.dataset.locationid,
                index + 1,
              );
            }
          }
        }
        falseDiv.replaceWith(child as Node);
      }
    }

    DragAndDrop.draggingPanelId = '';
    DragAndDrop.panelData = [];
    DragAndDrop.drawMinimap();

    DragAndDrop.removePlaceholder();
  }
}
